<div
  [ngClass]="lightColour ? 'eq-card-light' : 'eq-card-dark'"
  class="eq-card-expanding eq-group eq-p-[44px] eq-h-[290px] eq-w-[344px] eq-overflow-hidden eq-shadow-md hover:eq-h-[394px]"
>
  <div class="eq-flex eq-flex-col">
    <div *ngIf="rendering.fields?.SmallText?.value" class="eq-text-body-sm-m lg:eq-text-body-sm eq-mb-[21px]">{{rendering.fields?.SmallText?.value}}</div>
    <h2 *ngIf="rendering.fields?.Title?.value" class="eq-font-bold eq-text-heading5-m eq-mb-[21px] lg:eq-text-heading5">
      {{rendering.fields?.Title?.value}}
    </h2>
  </div>
  <p *ngIf="rendering.fields?.Description?.value"
    class="eq-text-body-sm-m lg:eq-text-body-sm eq-hidden eq-absolute -eq-translate-y-6 eq-opacity-0 eq-duration-[1s] eq-ease-out group-hover:eq-static group-hover:eq-block group-hover:eq-translate-y-0 group-hover:eq-opacity-100"
  >
  {{rendering.fields?.Description?.value}}
  </p>
  <a *ngIf="rendering.fields?.Link?.value?.href" [attr.label]="rendering.fields?.Link?.value?.text" hybridHref href="{{rendering.fields?.Link?.value?.href}}" [target]="rendering.fields?.Link?.value?.target" [attr.rel]="rendering.fields?.Link?.value?.target == '_blank' ? 'noopener' : null" class="eq-flex eq-w-fit eq-items-center eq-mt-6 eq-gap-x-3">
    <div class="eq-block eq-text-sm eq-font-bold lg:eq-hidden">{{rendering.fields?.Link?.value?.text}}</div>
    <div
      class="eq-hidden eq-text-sm eq-font-bold eq-absolute eq-duration-[1s] lg:eq-inline-block lg:eq-opacity-0 group-hover:eq-opacity-100 group-hover:eq-translate-x-0 lg:eq-ease-out lg:eq-transition-all group-hover:eq-static"
    >
      {{rendering.fields?.Link?.value?.text}}
    </div>
    <div class="eq-flex eq-items-center">
      <i class="eq-icon-arrow_right eq-text-i-24"></i>
    </div>
  </a>
</div>